import React from "react";

function Portfolio() {
  const projects = [
    {
      icon: "ri-database-2-line",
      category: "Enterprise IT",
      title: "Enterprise IT Infrastructure Management",
      desc: "Managed Linux (RHEL) and Windows Server infrastructure for 10+ mission-critical healthcare applications, including Apache web server configuration, application deployment, and hosting environment maintenance across development, test, and production environments."
    },
    {
      icon: "ri-settings-3-line",
      category: "Enterprise IT",
      title: "DevOps & CI/CD Automation",
      desc: "Built and maintained CI/CD pipelines to automate deployment processes, reducing deployment time and improving release management efficiency. Implemented workflow automation using cron jobs, batch monitoring scripts, and AI-powered tools, reducing manual intervention by 40%."
    },
    {
      icon: "ri-exchange-box-line",
      category: "Enterprise IT",
      title: "Application Migration & Infrastructure Modernization",
      desc: "Led 5+ application migration initiatives involving Linux servers, PHP applications, and PostgreSQL databases, coordinating with infrastructure teams to ensure seamless transitions with zero critical business disruption."
    },
    {
      icon: "ri-shield-user-line",
      category: "Enterprise IT",
      title: "Active Directory Application",
      desc: "Enterprise user provisioning and identity management system with automated workflow integration."
    },
    {
      icon: "ri-wifi-line",
      category: "Enterprise IT",
      title: "Network MAC Registry",
      desc: "Automated network device registration and MAC address management system with real-time monitoring."
    },
    {
      icon: "ri-speed-line",
      category: "Performance & SEO",
      title: "Website Performance Optimization",
      desc: "Implemented Core Web Vitals optimization, technical SEO best practices, and page speed improvements for enterprise healthcare applications, achieving 40% faster load times."
    },
    {
      icon: "ri-cloud-line",
      category: "Infrastructure",
      title: "DNS & SSL Management System",
      desc: "Configured and managed DNS records, SSL certificates, and Cloudflare CDN integration for secure, high-performance hosting environments across multiple domains."
    },
    {
      icon: "ri-hospital-line",
      category: "Healthcare",
      title: "HAP - High Alert Patients",
      desc: "Critical patient monitoring and alert management system for healthcare providers."
    },
    {
      icon: "ri-nurse-line",
      category: "Healthcare",
      title: "WOCN",
      desc: "Wound, Ostomy, and Continence Nursing management system."
    },
    {
      icon: "ri-heart-pulse-line",
      category: "Healthcare",
      title: "PICC & POCT",
      desc: "Peripherally Inserted Central Catheter tracking and Point-of-Care Testing management."
    },
    {
      icon: "ri-building-4-line",
      category: "Web Apps",
      title: "WFM System",
      desc: "Enterprise workforce management system for construction company."
    },
    {
      icon: "ri-customer-service-line",
      category: "Web Apps",
      title: "Help Desk System",
      desc: "Online help desk application for ticket management."
    },
    {
      icon: "ri-shopping-cart-2-line",
      category: "Web Apps",
      title: "POS System",
      desc: "Point-of-sale solution for retail businesses."
    },
    {
      icon: "ri-store-2-line",
      category: "Web Apps",
      title: "DayDreams",
      desc: "Online cosmetics e-commerce platform with admin panel."
    },
    {
      icon: "ri-netflix-fill",
      category: "Web Apps",
      title: "Netflix Clone",
      desc: "Streaming platform interface clone built with React."
    },
    {
      icon: "ri-graduation-cap-line",
      category: "Web Apps",
      title: "E-LMS System",
      desc: "Learning management system admin panel."
    },
    {
      icon: "ri-file-list-3-line",
      category: "Web Apps",
      title: "Learning Resource Center",
      desc: "Online results management system."
    },
    {
      icon: "ri-vote-line",
      category: "Web Apps",
      title: "Voting Application",
      desc: "Online election voting system."
    },
    {
      icon: "ri-checkbox-line",
      category: "Web Apps",
      title: "To Do App",
      desc: "Task management application built with React."
    },
    {
      icon: "ri-restaurant-line",
      category: "Web Apps",
      title: "WTD Restaurant",
      desc: "Online food ordering and table reservation platform."
    }
  ];

  return (
    <section id="portfolio" className="portfolio">
      <div className="container">
        <div className="section-title">
          <h2>Portfolio</h2>
          <p>Key Projects</p>
        </div>

        <div className="row">
          <div className="col-lg-12 d-flex justify-content-center mb-4">
            <ul id="portfolio-flters">
              <li data-filter="*" className="filter-active">All</li>
              <li data-filter=".filter-enterprise">Enterprise IT</li>
              <li data-filter=".filter-infrastructure">Infrastructure</li>
              <li data-filter=".filter-performance">Performance & SEO</li>
              <li data-filter=".filter-healthcare">Healthcare</li>
              <li data-filter=".filter-web">Web Apps</li>
            </ul>
          </div>
        </div>

        <div className="row portfolio-container">
          {projects.map((project, index) => (
            <div
              key={index}
              className={`col-lg-4 col-md-6 portfolio-item filter-${project.category === "Enterprise IT" ? "enterprise" : project.category === "Infrastructure" ? "infrastructure" : project.category === "Performance & SEO" ? "performance" : project.category === "Healthcare" ? "healthcare" : "web"}`}
            >
              <div className="portfolio-card">
                <div className="portfolio-card-icon">
                  <i className={project.icon}></i>
                </div>
                <div className="portfolio-card-body">
                  <span className="portfolio-card-category">{project.category}</span>
                  <h4>{project.title}</h4>
                  <p>{project.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
